import { useMemo, useEffect } from 'react';
import { oneYearFromNow } from 'widgets/region-selector/js/util';

export const useCheckBarStatus = (
    cookieStatus,
    calloutTextStatus,
    setCalloutTextStatus
) => {
    useEffect(() => {
        let hasLogicRun = false;

        if (cookieStatus === 'barIgnored' && calloutTextStatus === 'false') {
            setCalloutTextStatus('true');
            PULSE.core.localStorage.setStorage(
                'calloutTextStatus',
                'true',
                oneYearFromNow(),
                true
            );
        }

        if (cookieStatus === 'barIgnored' && calloutTextStatus === 'true') {
            setCalloutTextStatus('dismissed');
            PULSE.core.localStorage.setStorage(
                'calloutTextStatus',
                'dismissed',
                oneYearFromNow(),
                true
            );
        }

        if (cookieStatus === 'barUsed') {
            setCalloutTextStatus('dismissed');
            PULSE.core.localStorage.setStorage(
                'calloutTextStatus',
                'dismissed',
                oneYearFromNow(),
                true
            );
        }

        const handleBeforeUnload = () => {
            if (!hasLogicRun) {
                if (cookieStatus === 'barInitialised') {
                    PULSE.core.localStorage.setStorage(
                        'regionBarStatus',
                        'barIgnored',
                        oneYearFromNow(),
                        true
                    );
                }
                hasLogicRun = true;
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);
};

export const useCreateLocations = (data) => {
    return useMemo(() => {
        if (data.length) {
            return data.reduce((regions, region) => {
                const value = PULSE.app.common.modifyCountryDisplay(
                    region.timezone.split('/')[0]
                );

                const returnValue = {
                    name: value,
                    value,
                    extra: region
                };

                if (!regions.find((obj) => obj.name === returnValue.name)) {
                    regions.push(returnValue);
                }

                return regions.sort((textA, textB) =>
                    textA.name < textB.name
                        ? -1
                        : textA.name > textB.name
                        ? 1
                        : 0
                );
            }, []);
        }
    }, [data]);
};

export const useCreateRegions = (data, selectedLocation) => {
    return useMemo(() => {
        return data
            .filter(
                (region) =>
                    PULSE.app.common.modifyCountryDisplay(
                        region.timezone.split('/')[0]
                    ) === selectedLocation
            )
            .sort((a, b) => {
                return a.name.localeCompare(b.name);
            });
    }, [data, selectedLocation]);
};
